import { Modal } from "bootstrap";
import Slider from "./slider";

export default class MasonryGallery {
  constructor(container) {
    this.container = container;
    this.items = [...this.container.querySelectorAll(".mm-masonry__item")];
    this.columnGap = this.container.dataset.masonryColumnGap || 16;

    this.initColumnWidth();
    this.initImages();
    this.initModal();
  }

  getUnloadedItems() {
    return this.items.filter((item) => !item.dataset?.loaded);
  }

  initImages() {
    this.getUnloadedItems().forEach((item) => {
      const image = item.querySelector(".mm-masonry__img");
      image.addEventListener("load", () => {
        item.style.setProperty("--w", image.naturalWidth);
        item.style.setProperty("--h", image.naturalHeight);
        item.querySelectorAll("[data-show-on-loaded]").forEach((el) => {
          el.classList.remove("d-none");
        });
      });
    });

    // initially load first images
    this.getUnloadedItems()
      .slice(0, 12)
      .forEach((item) => this.loadImage(item));

    const preloadDistance = 1000;

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.loadImage(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        {
          root: null,
          rootMargin: `${preloadDistance}px 0px`,
          threshold: 0,
        }
      );

      this.getUnloadedItems().forEach((item) => {
        observer.observe(item);
      });
      return;
    }

    window.addEventListener("scroll", () => {
      this.getUnloadedItems().forEach((item) => {
        const itemDimensions = item.getBoundingClientRect();
        const limit = window.innerHeight + preloadDistance;
        if (itemDimensions.top < limit && itemDimensions.bottom > 0) {
          this.loadImage(item);
        }
      });
    });
  }

  loadImage(item) {
    const image = item.querySelector(".mm-masonry__img");
    document
      .querySelectorAll('[data-src="' + image.dataset.src + '"]')
      .forEach((image) => {
        image.setAttribute("src", image.dataset.src);
        item.dataset.loaded = true;
      });
  }

  initColumnWidth() {
    const setColumnWidth = () => {
      const containerWidth = this.container.getBoundingClientRect().width;
      const screenWidth = window.innerWidth;
      const isMobile = screenWidth < 768;
      if (!isMobile) {
        const isDesktop = screenWidth >= 992;
        const columnCount = isDesktop ? 3 : 2;
        const columnWidth =
          (containerWidth - this.columnGap * (columnCount - 1)) / columnCount;

        this.container.style.setProperty("--col-width", columnWidth);
        this.container.style.setProperty("--gap", this.columnGap);
      }
    };

    setColumnWidth();
    window.addEventListener("resize", setColumnWidth);
  }

  initModal() {
    const modalEl = document.querySelector(this.container.dataset.targetModal);
    const modal = new Modal(modalEl);
    const sliderContainer = document.querySelector(
      this.container.dataset.targetCarousel
    );
    let slider = null;

    const getSlider = () => {
      if (!slider) {
        slider = new Slider(sliderContainer);
      }
      return slider;
    };

    this.items.forEach((item) => {
      const { galleryIndex } = item.dataset;
      item.addEventListener("click", () => {
        const slider = getSlider();
        slider.goToSlide(galleryIndex);
        modal.show();
        if (slider.hasIndicators) {
          slider.scrollIndicators({ to: galleryIndex });
        }
      });
    });

    modalEl.addEventListener("hide.bs.modal", () => {
      if (slider) {
        slider.pauseVideo();
      }
    });
  }
}
